import { c as _c } from "react/compiler-runtime";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { RelayKitProvider } from "@relayprotocol/relay-kit-ui";
import { fetchChainConfigs, MAINNET_RELAY_API } from "@relayprotocol/relay-sdk";
import { useEffect, useState } from "react";
export function RelayKitProviderWrapper(t0) {
  const $ = _c(7);
  const {
    children,
    simDuneApiKey
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [relayChains, setRelayChains] = useState(t1);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const fetchChains = async () => {
        const chains = await fetchChainConfigs(MAINNET_RELAY_API);
        setRelayChains(chains);
      };
      fetchChains();
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== children || $[4] !== relayChains || $[5] !== simDuneApiKey) {
    t4 = _jsx(RelayKitProvider, {
      options: {
        baseApiUrl: MAINNET_RELAY_API,
        source: "anyspend",
        duneConfig: {
          apiKey: simDuneApiKey,
          apiBaseUrl: "https://api.sim.dune.com"
        },
        chains: relayChains,
        privateChainIds: undefined,
        appName: "AnySpend",
        useGasFeeEstimations: true
      },
      children: _jsx(_Fragment, {
        children
      })
    });
    $[3] = children;
    $[4] = relayChains;
    $[5] = simDuneApiKey;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}